// Local module to retrieve the window.document object, primarily for
// ease of mocking it in tests.
const windowDocument = () => window.document;

export default windowDocument;
